import Api from "../../lib/api";

export const DONORS_CONTRIBUTIONS_LIST = {
  start: "fetch_start/donors_contributions_list",
  end: "fetch_end/donors_contributions_list",
  success: "fetch_success/donors_contributions_list",
  failed: "fetch_failed/donors_contributions_list",
};

export const donorsContributionsListFetchStart = () => ({
  type: DONORS_CONTRIBUTIONS_LIST.start,
});

export const donorsContributionsListFetchEnd = () => ({
  type: DONORS_CONTRIBUTIONS_LIST.end,
});

export const donorsContributionsListFetchSuccess = (data) => ({
  type: DONORS_CONTRIBUTIONS_LIST.success,
  data,
});

export const donorsContributionsListFetchFailed = (error) => ({
  type: DONORS_CONTRIBUTIONS_LIST.failed,
  error,
});

export const updateContributionsList = (year, portal) => (dispatch) => {
  dispatch(donorsContributionsListFetchStart());
  if (year !== null) {
    return Api.get(Api.API_DONORS_CONTRIBUTIONS_LIST(year, portal))
      .then((response) => {
        dispatch(donorsContributionsListFetchEnd());
        dispatch(donorsContributionsListFetchSuccess(response.data));
      })
      .catch((exception) => {
        dispatch(donorsContributionsListFetchEnd());
        dispatch(donorsContributionsListFetchFailed(exception));
      });
  }
};



// WEBPACK FOOTER //
// ./shared/actions/getDonorsContributionsList.js